import { useState, useEffect } from 'react';
import { detectBrand, clearBrandCache } from '../utils/brandDetection';

export function useBrand() {
  const [brand, setBrand] = useState(() => detectBrand());

  useEffect(() => {
    const handleNavigation = () => {
      clearBrandCache();
      const newBrand = detectBrand();
      setBrand(newBrand);
    };

    window.addEventListener('popstate', handleNavigation);
    window.addEventListener('hashchange', handleNavigation);

    const currentBrand = detectBrand();
    if (currentBrand.id !== brand.id) {
      setBrand(currentBrand);
    }

    return () => {
      window.removeEventListener('popstate', handleNavigation);
      window.removeEventListener('hashchange', handleNavigation);
    };
  }, [brand.id]);

  return brand;
}
